import Faraday1 from '../Faraday/Ruko Faraday.webp'
import Faraday2 from '../Faraday/Ruko Faraday.webp'


const Faradayimages =[
Faraday1,Faraday2
]

export default Faradayimages;